export default __webpack_public_path__ + "static/media/arrow-small-breadcrumb.3e14e7eb.svg";